import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

type Props = {
  field: RichTextField;
  /** Owned by the calling card, so each layout sets its own type scale. */
  className: string;
  /**
   * Optional weight for bold spans. Preflight sets `strong { font-weight:
   * bolder }`, which resolves to 400 inside a `font-light` paragraph — bold
   * spans lose their emphasis unless the serializer is overridden. Cards that
   * do not pass this keep the default rendering.
   */
  strongClassName?: string;
};

export function StepBody({ field, className, strongClassName }: Props) {
  return (
    <PrismicRichText
      field={field}
      components={{
        paragraph: ({ children }) => <p className={className}>{children}</p>,
        ...(strongClassName && {
          strong: ({ children }) => (
            <strong className={strongClassName}>{children}</strong>
          ),
        }),
      }}
    />
  );
}
